import script from "./HeroHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroHeader.vue?vue&type=script&setup=true&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=2205c9fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2205c9fc"]])

export default __exports__